<template>
  <div>
    <el-row
      type="flex"
      align="middle"
      class="route-block"
      :class="getRowClass(p)"
      v-for="(p, index) in routePeriods"
      :key="index"
      @click.native="clickRoute(p.id)"
    >
      <div class="route-id" :class="getBorderClass(p)">
        {{ p.id }}
      </div>
      <div class="margin-h7">
        {{ p.period }}
      </div>
      <i class="el-icon-close" @click="deleteRoute(p.id)"></i>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    routeId: [String, Number],
    routes: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    routePeriods() {
      let arr = [];
      this.routes.forEach((c) => {
        if (c.fitPeriods && c.fitPeriods.length) {
          c.fitPeriods.forEach((p) => {
            arr.push({
              id: c.id,
              period: p,
              isValid: c.isValid,
            });
          });
        } else {
          arr.push({
            id: c.id,
            period: "00:00-24:00",
            isValid: c.isValid,
          });
        }
      });
      arr.sort((a, b) => (a >= b ? 1 : -1));
      return arr;
    },
  },
  data() {
    return { itemTypes: ["primary", "success", "warning", "danger"] };
  },
  methods: {
    getRowClass(route) {
      const index = this.itemTypes[route.id % 4];
      let css = route.isValid ? "route-" + index : "route-info";
      if (route.id == this.routeId) css += " route-check";
      return css;
    },
    getBorderClass(route) {
      const index = this.itemTypes[route.id % 4];
      return route.isValid ? "border-" + index : "border-info";
    },
    clickRoute(id) {
      this.$emit("click", id);
    },
    deleteRoute(id){
      this.$emit("remove", id);
    }
  },
};
</script>

<style lang="scss" scoped>
i.el-icon-close:hover {
  font-weight: bold;
  color: #f56c6c;
}
.route-block {
  margin: 3px 0;
  padding: 3px;
  cursor: pointer;
  &.route-primary {
    background-color: #ecf5ff;
    border: 1px #ecf5ff solid;
    &.route-check {
      border-color: #409eff;
    }
  }
  &.route-success {
    background-color: #f0f9eb;
    border: 1px #f0f9eb solid;
    &.route-check {
      border-color: #67c23a;
    }
  }
  &.route-warning {
    background-color: #fdf6ec;
    border: 1px #f0f9eb solid;
    &.route-check {
      border-color: #e6a23c;
    }
  }
  &.route-danger {
    background-color: #fef0f0;
    border: 1px #f0f9eb solid;
    &.route-check {
      border-color: #f56c6c;
    }
  }
  &.route-info {
    background-color: #f4f4f5;
    border: 1px #f0f9eb solid;
    &.route-check {
      border-color: #909399;
    }
  }
  .route-id {
    height: 25px;
    width: 25px;
    line-height: 25px;
    border-radius: 50%;
    &.border-primary {
      border: 1px solid #409eff;
      color: #409eff;
    }
    &.border-success {
      border: 1px solid #67c23a;
      color: #67c23a;
    }
    &.border-warning {
      border: 1px solid #e6a23c;
      color: #e6a23c;
    }
    &.border-danger {
      border: 1px solid #f56c6c;
      color: #f56c6c;
    }
    &.border-info {
      border: 1px solid #909399;
      color: #909399;
    }
  }
}
</style>
